import _sum2 from "lodash/sum";
import _isEmpty2 from "lodash/isEmpty";
import _sumBy2 from "lodash/sumBy";
import _flow from "lodash/flow";
import _intersectionBy2 from "lodash/intersectionBy";
import _get2 from "lodash/get";
import _isFinite2 from "lodash/isFinite";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { checkIsApparel, getIsAlwaysInStock, getIsDisabledBySizeForSampleProduct, getTotalCount } from 'swag-client-common/utils/product.utils';
import { getProductOutOfStockThreshold } from 'swag-common/utils/product/product.utils';
import { isItemBlankSampleOrPrintedSample } from 'swag-common/utils/items/is-item-sample.service';
import isProductFullDesign from 'swag-common/utils/custom-store-product/product-is-full-design.util';
import { getLeftTime } from 'swag-common/utils/date-lib';
import isFullDesign from 'swag-common/utils/custom-store-product/product-is-full-design.util';
import { checkItemsHaveSkuQtyIssue } from 'swag-common/utils/product/le-check-is-items-has-sku-qty-issue.util';
import { isLEItem } from 'swag-common/utils/order';
import { getItemsWithRemovedPrintLocations, getItemsWithEmptyLogos } from 'swag-client-common/utils/cart.util';
import { isSuperSpeedItem } from 'swag-common/utils/items/is-item-super-speed.util';
const QNTY_PATH = ['variants', 0, 'quantities'];
export let ValidationPlaceMode = /*#__PURE__*/function (ValidationPlaceMode) {
  ValidationPlaceMode["orderMore"] = "ORDER_MORE";
  ValidationPlaceMode["cart"] = "CART";
  return ValidationPlaceMode;
}({});
function getProdVariant({
  prodVariants,
  itemVariant,
  itemColor = null
}) {
  if (_isFinite2(itemVariant.variantIndex)) {
    const variant = prodVariants[itemVariant.variantIndex];
    return variant || null;
  }
  const variant = prodVariants.find(variant => variant.color === itemColor);
  if (variant) {
    return variant;
  }
  return null;
}
export const _transformToObject = sizes => sizes.reduce((result, size) => {
  const key = Object.keys(size)[0];
  result[key] = size[key];
  return result;
}, {});
const _getItemSizeSet = item => {
  return _get2(item, ['prod', 'size', 'options'], []).reduce((result, size, idx) => {
    return result.concat([{
      [size]: _get2(item, [...QNTY_PATH, idx])
    }]);
  }, []);
};
export const getShortestSizeSet = items => {
  return _getGeneralSizeSet(items.filter(item => checkIsApparel(item.prod)).sort((a, b) => {
    const firstItemSizeSet = _getItemSizeSet(a);
    const secondItemSizeSet = _getItemSizeSet(b);
    return firstItemSizeSet.length - secondItemSizeSet.length;
  }), [0]);
};
const _getKey = size => Object.keys(size)[0];
const _buildGeneralSizeSet = itemsSets => _intersectionBy2(...itemsSets, _getKey);
export const _getGeneralSizeSet = _flow([items => items.map(_getItemSizeSet), _buildGeneralSizeSet]);
function getSizeDataFromSizeSet(sizeSet) {
  return Object.entries(sizeSet)[0];
}
export const _apparelDifferentSizeSet = (item, sizeSetToFit) => {
  const isApparel = checkIsApparel(item.prod);
  const itemSizeSet = _getItemSizeSet(item);
  if (!isApparel) {
    return [];
  }
  const existingSizes = sizeSetToFit.reduce((acc, sizeObj) => {
    const [size] = getSizeDataFromSizeSet(sizeObj);
    acc[size] = size;
    return acc;
  }, {});
  return itemSizeSet.reduce((result, sizeSet) => {
    const [size, value] = getSizeDataFromSizeSet(sizeSet);
    if (value !== 0 && !existingSizes[size]) {
      result.push(size);
    }
    return result;
  }, []);
};
export const _apparelIncorrectSizeQuantity = (item, items, box) => {
  const otherApparelsSizeSets = items.reduce((result, innerItem) => {
    if (!checkIsApparel(innerItem.prod) || innerItem.quantity / innerItem.quantityPerBox !== box.quantity) {
      return result;
    }
    const innerQuantityPerBox = innerItem.quantityPerBox || 1;
    const innerQuantity = innerItem.quantity || 1;
    const innerBoxQuantity = innerQuantity / innerQuantityPerBox;
    if (!checkIsApparel(innerItem.prod) || innerBoxQuantity !== box.quantity) {
      return result;
    }
    const sizeSets = _getItemSizeSet(innerItem);
    const existingSizes = sizeSets.reduce((acc, sizeObj) => {
      const [size, value] = getSizeDataFromSizeSet(sizeObj);
      const quantityToCompare = value / innerItem.quantityPerBox;
      acc[size] = quantityToCompare;
      return acc;
    }, {});
    result.push(existingSizes);
    return result;
  }, []);
  const currentItemSizeSet = _getItemSizeSet(item);
  return currentItemSizeSet.reduce((result, sizeObj) => {
    const [size, value] = getSizeDataFromSizeSet(sizeObj);
    const quantityToCompare = value / item.quantityPerBox;
    const remainder = value % item.quantityPerBox;
    const isAnyQuantityDifferent = otherApparelsSizeSets.some(otherApparelSizeSet => {
      var _otherApparelSizeSet$;
      return ((_otherApparelSizeSet$ = otherApparelSizeSet[size]) !== null && _otherApparelSizeSet$ !== void 0 ? _otherApparelSizeSet$ : 0) !== quantityToCompare;
    });
    if (remainder !== 0 || isAnyQuantityDifferent) {
      result.push(size);
    }
    return result;
  }, []);
};
const _getTotalQuantity = (item, items, variantsTotal = true) => {
  const {
    availableQuantities,
    asRelatedItemId,
    quantity,
    prod,
    _id
  } = item;
  if (availableQuantities) {
    return availableQuantities.reduce((a, b) => a + b, 0);
  }
  const relatedItems = (items || []).filter(i => i.asRelatedItemId === asRelatedItemId && i._id !== _id);
  if (!items || !asRelatedItemId || !relatedItems.length) {
    return quantity;
  }
  return _sumBy2(items, cartItem => {
    if (cartItem.asRelatedItemId === asRelatedItemId) {
      const isSharedItem = cartItem.prod._id === prod._id;
      if (!isSharedItem) {
        return cartItem.quantity;
      }
      if (variantsTotal) {
        return cartItem.variants.reduce((acc, v) => acc + v.quantities.reduce((a, b) => a + b, 0), 0);
      } else {
        const variantIndex = item.variants[0].variantIndex;
        const variant = cartItem.variants.find(v => v.variantIndex === variantIndex);
        if (variant) {
          return variant.quantities.reduce((a, b) => a + b, 0);
        }
      }
    }
    return 0;
  });
};
export const _quantityEqualOrMoreThanMax = (maxQuantity, item, items) => {
  const quantity = items ? _getTotalQuantity(item, items) : item.quantity;
  return quantity > maxQuantity;
};
export const _quantityOfAllSharedAndRelatedItemsLessThanMinQuant = (item, cartItems, minQuant) => {
  const isSuperSpeed = isSuperSpeedItem(item);
  const isSample = isItemBlankSampleOrPrintedSample(item);
  if (isSuperSpeed || isSample || item.availableQuantities || item.requiredQuantities) {
    return false;
  }
  const totalQuantity = _getTotalQuantity(item, cartItems);
  return totalQuantity < minQuant;
};
export const _quantityOfAllSharedAndRelatedSuperSpeedItemsLessThanMinQuant = (item, cartItems) => {
  var _item$prod$productSet, _item$prod, _item$prod$productSet2, _item$prod$productSet3, _item$prod$productSet4;
  const isSuperSpeed = isSuperSpeedItem(item);
  const isSample = isItemBlankSampleOrPrintedSample(item);
  if (!isSuperSpeed || isSample || item.availableQuantities || item.requiredQuantities) {
    return false;
  }
  const totalQuantity = _getTotalQuantity(item, cartItems);
  const superSpeedMinQuant = (_item$prod$productSet = (_item$prod = item.prod) === null || _item$prod === void 0 ? void 0 : (_item$prod$productSet2 = _item$prod.productSettings) === null || _item$prod$productSet2 === void 0 ? void 0 : (_item$prod$productSet3 = _item$prod$productSet2[0]) === null || _item$prod$productSet3 === void 0 ? void 0 : (_item$prod$productSet4 = _item$prod$productSet3.superSpeed) === null || _item$prod$productSet4 === void 0 ? void 0 : _item$prod$productSet4.minQuant) !== null && _item$prod$productSet !== void 0 ? _item$prod$productSet : 0;
  return totalQuantity < superSpeedMinQuant;
};
export const _quantityPerBoxIsZero = item => {
  return item.quantityPerBox === 0;
};
export const _boxQuantityLessThanMinQuant = (box, needToUseDynamicMinQuantity) => {
  var _box$prod, _box$prod$productSett, _box$prod$productSett2, _box$prod2;
  const minQuant = needToUseDynamicMinQuantity ? ((_box$prod = box.prod) === null || _box$prod === void 0 ? void 0 : (_box$prod$productSett = _box$prod.productSettings) === null || _box$prod$productSett === void 0 ? void 0 : (_box$prod$productSett2 = _box$prod$productSett[0]) === null || _box$prod$productSett2 === void 0 ? void 0 : _box$prod$productSett2.minQuant) || 0 : (_box$prod2 = box.prod) === null || _box$prod2 === void 0 ? void 0 : _box$prod2.minQuant;
  return box.quantity < minQuant;
};
export const _isSampleProductSizesIsAllOutOfStock = (item, stockLevelsByProductIdAndVariantSku) => {
  if (!item.isSample && !item.isPrintedSample || !item.prod.hasSize) {
    return false;
  }
  const disabledLevelsForVariant = getIsDisabledBySizeForSampleProduct(item, stockLevelsByProductIdAndVariantSku);
  return disabledLevelsForVariant.every(lvl => lvl);
};
export const _isSampleProductSelectedSizeIsOutOfStock = (item, stockLevelsByProductIdAndVariantSku) => {
  if (!item.isSample && !item.isPrintedSample || !item.prod.hasSize) {
    return false;
  }
  const disabledLevelsForVariant = getIsDisabledBySizeForSampleProduct(item, stockLevelsByProductIdAndVariantSku);
  return disabledLevelsForVariant[item.sizeInd];
};
export const _totalProductQuantityMoreThanAvailableInCart = item => {
  if (!item.availableQuantities) {
    return false;
  }
  return item.quantity > getTotalCount(item.availableQuantities);
};
export const _totalProductQuantityPerSizeMoreThanAvailableInCart = item => {
  if (!item || !item.availableQuantities || !checkIsApparel(item.prod)) {
    return false;
  }
  return item.variants[0].quantities.some((quantityForSize, index) => {
    const availableQuantities = item.availableQuantities || [];
    return quantityForSize > (availableQuantities[index] || 0);
  });
};
export const _apparelQuantityBiggerThanBoxQuantity = (item, box) => {
  if (!item || !box) {
    return false;
  }
  const quantityPerBox = item.quantityPerBox || 1;
  const isApparel = checkIsApparel(item.prod);
  const isWithPositiveNumber = item.quantity % box.quantity !== 0;
  const isQuantityNotEqualToRequired = item.quantity !== box.quantity * quantityPerBox;
  return isApparel && (isWithPositiveNumber || isQuantityNotEqualToRequired);
};
function getIsAlwaysInStockForVariant(item) {
  const currentProductVariant = item.prod.variants.find((variant, index) => {
    var _item$variants$;
    return ((_item$variants$ = item.variants[0]) === null || _item$variants$ === void 0 ? void 0 : _item$variants$.variantIndex) === index || item.productSku === variant.productSku;
  });
  return getIsAlwaysInStock(item.prod) || item.isAlwaysInStockVariant || _get2(currentProductVariant, 'isAlwaysInStockVariant', false);
}
export const _moreThanAvailableInStockSingleVariant = (item, inStock, items) => {
  const totalQuantity = items ? _getTotalQuantity(item, items, false) : item.quantity;
  if (item.variants.length > 1) {
    return false;
  }
  const isAlwaysInStock = getIsAlwaysInStockForVariant(item);
  return _isFinite2(inStock) && !isAlwaysInStock ? totalQuantity > inStock : false;
};
export const _isLETotalNotAvailable = (item, minQuant, stockLevelsByProductIdAndVariantSku) => {
  var _stockLevelsByProduct;
  const {
    limitedEdition,
    variants: prodVariants,
    hasSize,
    num
  } = item.prod;
  const itemVariantsIndexes = item.variants.map(({
    variantIndex
  }) => variantIndex);
  const isExpired = (limitedEdition === null || limitedEdition === void 0 ? void 0 : limitedEdition.expirationDate) && getLeftTime(new Date(limitedEdition.expirationDate)) <= 0;
  if (isExpired) {
    return true;
  }
  if (!(limitedEdition !== null && limitedEdition !== void 0 && limitedEdition.isLimitedEdition) || _isEmpty2(stockLevelsByProductIdAndVariantSku === null || stockLevelsByProductIdAndVariantSku === void 0 ? void 0 : stockLevelsByProductIdAndVariantSku[item.prod._id])) {
    return false;
  }
  const stockLevelsByVariantSku = (_stockLevelsByProduct = stockLevelsByProductIdAndVariantSku === null || stockLevelsByProductIdAndVariantSku === void 0 ? void 0 : stockLevelsByProductIdAndVariantSku[item.prod._id]) !== null && _stockLevelsByProduct !== void 0 ? _stockLevelsByProduct : {};
  let total = 0;
  if (!limitedEdition.isInfinity) {
    if (isProductFullDesign(item.prod)) {
      var _stockLevelsByVariant;
      total += (_stockLevelsByVariant = stockLevelsByVariantSku[num]) !== null && _stockLevelsByVariant !== void 0 ? _stockLevelsByVariant : 0;
    } else {
      prodVariants.forEach(({
        sizeSkus,
        productSku: variantSku
      }, index) => {
        if (!itemVariantsIndexes.includes(index)) {
          return;
        }
        if (hasSize) {
          for (const size in sizeSkus) {
            var _stockLevelsByVariant2;
            variantSku = sizeSkus[size];
            total += (_stockLevelsByVariant2 = stockLevelsByVariantSku[variantSku]) !== null && _stockLevelsByVariant2 !== void 0 ? _stockLevelsByVariant2 : 0;
          }
        } else {
          var _stockLevelsByVariant3;
          total += (_stockLevelsByVariant3 = stockLevelsByVariantSku[variantSku]) !== null && _stockLevelsByVariant3 !== void 0 ? _stockLevelsByVariant3 : 0;
        }
      });
    }
  }
  const isOOS = limitedEdition.isInfinity ? false : total < minQuant;
  return isOOS;
};
export const _isNotAllowedInBox = item => {
  var _item$prod2;
  return !!(item !== null && item !== void 0 && (_item$prod2 = item.prod) !== null && _item$prod2 !== void 0 && _item$prod2.forbiddenForBox);
};
export const _LEMoreThanAvailableInStockSingleVariant = (item, items, minQuant, inStock) => {
  const {
    limitedEdition
  } = item.prod;
  if (!inStock || !limitedEdition.isLimitedEdition || limitedEdition.isLimitedEdition && limitedEdition.isInfinity) {
    return false;
  }
  if (inStock < minQuant) {
    return false;
  }
  const totalQuantity = _getTotalQuantity(item, items, false);
  if (item.variants.length > 1) {
    return false;
  }
  return _isFinite2(inStock) ? totalQuantity > inStock : false;
};
export const _LEMultipleItemsSumError = ({
  item,
  items,
  lvls
}) => {
  const isItemLE = isLEItem(item);
  const hasOrderSimilarLEItems = checkItemsHaveSimilarLEItems({
    items,
    item
  });
  if (!isItemLE || !hasOrderSimilarLEItems) {
    return false;
  }
  const hasOrderSkuQtyIssue = checkItemsHaveSkuQtyIssue({
    lvls,
    splitter: '*',
    items: items,
    testedProdIds: items.map(it => it.prod._id)
  });
  return hasOrderSkuQtyIssue;
};
export const _LEMulticolorPerSkuError = ({
  item,
  lvls
}) => {
  const isItemLE = isLEItem(item);
  const isItemMultiColor = item.variants.length > 1;
  const hasItemSkuQtyIssue = checkItemsHaveSkuQtyIssue({
    lvls,
    splitter: '*',
    items: [item],
    testedProdIds: [item.prod._id]
  });
  return isItemLE && isItemMultiColor && hasItemSkuQtyIssue;
};
export const _isOutOfStock = (item, minQuant, stockLevelsByProductIdAndVariantSku) => {
  var _item$prod$limitedEdi;
  if ((_item$prod$limitedEdi = item.prod.limitedEdition) !== null && _item$prod$limitedEdi !== void 0 && _item$prod$limitedEdi.isLimitedEdition) {
    return false;
  }
  const stockLevelsByVariantSku = (stockLevelsByProductIdAndVariantSku === null || stockLevelsByProductIdAndVariantSku === void 0 ? void 0 : stockLevelsByProductIdAndVariantSku[item.prod._id]) || {};
  const threshold = getProductOutOfStockThreshold({
    outOfStockThreshold: item.prod.outOfStockThreshold,
    supplierOutOfStockThreshold: item.prod.supplierOutOfStockThreshold || 0,
    limitedEdition: item.prod.limitedEdition,
    minQuant
  });
  const isAlwaysInStock = getIsAlwaysInStockForVariant(item);
  if (isAlwaysInStock || !_isFinite2(threshold) && !isProductFullDesign(item.prod)) {
    return false;
  }
  if (isProductFullDesign(item.prod)) {
    const inStock = stockLevelsByVariantSku[item.prod.num];
    if (!_isFinite2(inStock)) {
      return false;
    }
    return inStock === 0;
  }
  if (!item.prod.hasSize) {
    const skuIndex = getBoxVariantSku(item);
    if (skuIndex === undefined) {
      return false;
    }
    const inStock = stockLevelsByVariantSku[skuIndex];
    if (!_isFinite2(inStock)) {
      return false;
    }
    return inStock === 0 || inStock <= threshold;
  }
  return item.variants.every(variant => {
    var _item$prod3;
    const productVariant = getProdVariant({
      prodVariants: item.prod.variants,
      itemVariant: variant,
      itemColor: item.color || null
    });
    if (!productVariant) {
      return false;
    }
    const {
      sizeSkus
    } = productVariant;
    const size = ((_item$prod3 = item.prod) === null || _item$prod3 === void 0 ? void 0 : _item$prod3.productSize) || {
      options: []
    };
    return size.options.every(sizeLabel => {
      const skuIndex = sizeSkus === null || sizeSkus === void 0 ? void 0 : sizeSkus[sizeLabel];
      if (skuIndex === undefined) {
        return false;
      }
      const currentInStock = stockLevelsByVariantSku[skuIndex];
      if (!_isFinite2(currentInStock)) {
        return false;
      }
      return currentInStock === 0 || currentInStock <= threshold;
    });
  });
};
export const _someColorsOutOfStock = (item, stockLevelsByProductIdAndVariantSku, items) => {
  if (item.variants.length === 1) {
    return false;
  }
  const {
    supplierOutOfStockThreshold
  } = item.prod;
  const threshold = getProductOutOfStockThreshold(_objectSpread({}, item.prod, {
    supplierOutOfStockThreshold: supplierOutOfStockThreshold || 0
  }));
  const isAlwaysInStockProduct = getIsAlwaysInStock(item.prod);
  const isMultiColor = item.variants.length > 1;
  let multiColorTotalInStock = null;
  if (isMultiColor) {
    multiColorTotalInStock = item.variants.reduce((acc, variant) => {
      var _stockLevelsByProduct2;
      const productVariant = getProdVariant({
        prodVariants: item.prod.variants,
        itemVariant: variant
      });
      if (!productVariant) {
        return acc;
      }
      const {
        productSku
      } = productVariant;
      const inStock = stockLevelsByProductIdAndVariantSku === null || stockLevelsByProductIdAndVariantSku === void 0 ? void 0 : (_stockLevelsByProduct2 = stockLevelsByProductIdAndVariantSku[item.prod._id]) === null || _stockLevelsByProduct2 === void 0 ? void 0 : _stockLevelsByProduct2[productSku || ''];
      return _isFinite2(inStock) ? Number(acc) + inStock : acc;
    }, null);
  }
  for (const variant of item.variants) {
    var _stockLevelsByProduct3;
    const quantity = items ? _getTotalQuantity(_objectSpread({}, item, {
      variants: [variant]
    }), items, false) : item.quantity;
    const productVariant = getProdVariant({
      prodVariants: item.prod.variants,
      itemVariant: variant
    });
    if (!productVariant) {
      return false;
    }
    const {
      isAlwaysInStockVariant,
      productSku
    } = productVariant;
    const isAlwaysInStock = Boolean(isAlwaysInStockVariant || isAlwaysInStockProduct);
    const inStock = isMultiColor ? multiColorTotalInStock : stockLevelsByProductIdAndVariantSku === null || stockLevelsByProductIdAndVariantSku === void 0 ? void 0 : (_stockLevelsByProduct3 = stockLevelsByProductIdAndVariantSku[item.prod._id]) === null || _stockLevelsByProduct3 === void 0 ? void 0 : _stockLevelsByProduct3[productSku || ''];
    if (!isAlwaysInStock) {
      const isOutOfStock = _isFinite2(inStock) && _isFinite2(threshold) ? Number(inStock) < quantity : false;
      if (isOutOfStock) {
        return true;
      }
    }
  }
};
export const _mismatchesRequiredQuantity = item => {
  if (!item.requiredQuantities) {
    return false;
  }
  if (checkIsApparel(item.prod)) {
    var _item$prod4, _item$prod4$size;
    const sizeOptions = ((_item$prod4 = item.prod) === null || _item$prod4 === void 0 ? void 0 : (_item$prod4$size = _item$prod4.size) === null || _item$prod4$size === void 0 ? void 0 : _item$prod4$size.options) || [];
    const variant = item.variants[0];
    const mismatchedQuantities = sizeOptions.reduce((result, size, index) => {
      const currentSizeQuantity = variant.quantities[index];
      const requiredQuantities = item.requiredQuantities || [];
      const currentRequiredSizeQuantity = requiredQuantities[index];
      if (currentSizeQuantity < currentRequiredSizeQuantity) {
        result.push({
          [size]: currentRequiredSizeQuantity
        });
      }
      return result;
    }, []);
    return mismatchedQuantities.length > 0 ? mismatchedQuantities : false;
  }
  const requiredQuantities = _sum2(item.requiredQuantities);
  return item.quantity < requiredQuantities ? requiredQuantities : false;
};
const _getTotalQuantityPerVariantAndSize = (item, variantIndex, sizeIndex, items) => {
  if (!items) {
    const variant = item.variants.find(v => v.variantIndex === variantIndex);
    if (!variant) {
      return 0;
    }
    return variant.quantities[sizeIndex] || 0;
  }
  const sharedItems = items.filter(i => i.asRelatedItemId === item.asRelatedItemId && i.prod._id === item.prod._id);
  return sharedItems.reduce((acc, i) => {
    const variant = i.variants.find(v => v.variantIndex === variantIndex);
    if (!variant) {
      return 0;
    }
    return variant ? acc + (variant.quantities[sizeIndex] || 0) : acc;
  }, 0);
};
export const _someColorsOrSizesMoreThanAvailable = (item, stockLevelsByProductIdAndVariantSku, items) => {
  if (!item || !item.prod.hasSize) {
    return {};
  }
  const {
    supplierOutOfStockThreshold,
    _id: productId
  } = item.prod;
  const stockLevelsByVariantSku = (stockLevelsByProductIdAndVariantSku === null || stockLevelsByProductIdAndVariantSku === void 0 ? void 0 : stockLevelsByProductIdAndVariantSku[productId]) || {};
  const threshold = getProductOutOfStockThreshold(_objectSpread({}, item.prod, {
    supplierOutOfStockThreshold: supplierOutOfStockThreshold || 0
  }));
  const isAlwaysInStockProduct = getIsAlwaysInStock(item.prod);
  if (!_isFinite2(threshold) || isAlwaysInStockProduct) {
    return {};
  }
  const result = {};
  item.variants.forEach((variant, index) => {
    var _item$prod5, _item$prod6;
    const productVariant = getProdVariant({
      prodVariants: ((_item$prod5 = item.prod) === null || _item$prod5 === void 0 ? void 0 : _item$prod5.variants) || [],
      itemVariant: variant,
      itemColor: item.color || null
    });
    if (!productVariant || productVariant.isAlwaysInStockVariant) {
      return false;
    }
    const {
      sizeSkus
    } = productVariant;
    const size = ((_item$prod6 = item.prod) === null || _item$prod6 === void 0 ? void 0 : _item$prod6.productSize) || {
      options: []
    };
    size.options.forEach((sizeLabel, sizeIndex) => {
      const currentQuantity = _getTotalQuantityPerVariantAndSize(item, variant.variantIndex, sizeIndex, items);
      const skuIndex = sizeSkus === null || sizeSkus === void 0 ? void 0 : sizeSkus[sizeLabel];
      if (skuIndex === undefined) {
        return false;
      }
      const currentInStock = stockLevelsByVariantSku[skuIndex];
      if (!_isFinite2(currentInStock)) {
        return false;
      }
      if (currentQuantity > currentInStock) {
        result[index] = result[index] || {};
        result[index][sizeLabel] = {
          inStock: currentInStock
        };
      }
    });
  });
  return result;
};
export const _quantityDivisibleByQuantityIncrement = item => {
  const {
    prod,
    blendedQuantity,
    cartQuantities
  } = item;
  if (isItemBlankSampleOrPrintedSample(item)) {
    return false;
  }
  const isSharedProductInCart = cartQuantities && cartQuantities[0] === 0;
  const isQuantIncrementHasRest = (blendedQuantity || 0) % prod.quantIncrement !== 0;
  if (isSharedProductInCart && isQuantIncrementHasRest) {
    return false;
  }
  return isQuantIncrementHasRest;
};
export function getFirstVariantSku(item) {
  var _item$variants$2;
  if (isFullDesign(item.prod)) {
    var _item$prod7;
    return (_item$prod7 = item.prod) === null || _item$prod7 === void 0 ? void 0 : _item$prod7.num;
  }
  const fullVariant = item.prod.variants[(_item$variants$2 = item.variants[0]) === null || _item$variants$2 === void 0 ? void 0 : _item$variants$2.variantIndex];
  return fullVariant === null || fullVariant === void 0 ? void 0 : fullVariant.productSku;
}
export function getBoxVariantSku(item) {
  var _item$prod8;
  return getFirstVariantSku(item) || item.itemSku || item.productSku || ((_item$prod8 = item.prod) === null || _item$prod8 === void 0 ? void 0 : _item$prod8.num) || '';
}
export const _perBox = (item, box) => {
  const quantityPerBox = item.quantityPerBox || 1;
  const generalQuantity = box.quantity * quantityPerBox;
  return item.quantity < generalQuantity;
};
export const _isHidden = item => {
  if (item.prod.hidden) {
    return true;
  }
  return item.variants.some(variant => {
    const productVariant = getProdVariant({
      prodVariants: item.prod.variants,
      itemVariant: variant,
      itemColor: item.color || null
    });
    return productVariant === null || productVariant === void 0 ? void 0 : productVariant.isHidden;
  });
};
export const _isBoxWithLEOrderMore = (item, mode) => {
  var _item$prod9, _item$prod9$limitedEd;
  return mode === ValidationPlaceMode.orderMore && ((_item$prod9 = item.prod) === null || _item$prod9 === void 0 ? void 0 : (_item$prod9$limitedEd = _item$prod9.limitedEdition) === null || _item$prod9$limitedEd === void 0 ? void 0 : _item$prod9$limitedEd.isLimitedEdition);
};
export const _isSomeItemPrintLocationRemoved = item => {
  const result = getItemsWithRemovedPrintLocations([item]);
  return !!result.length;
};
export const _isItemLogosEmpty = item => {
  const result = getItemsWithEmptyLogos([item]);
  return !!result.length;
};
const checkItemsHaveSimilarLEItems = ({
  item,
  items
}) => {
  const isLE = isLEItem(item);
  if (!isLE) {
    return false;
  }
  return items.some(it => isLEItem(it) && it._id !== item._id && item.prod._id === it.prod._id);
};